import { Card, Row, Col, Button } from '@themesberg/react-bootstrap'
import React, { useState } from 'react'
import { ExclamationCircleOutlined, InboxOutlined } from '@ant-design/icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useSetRecoilState } from 'recoil';
import { Form, Input, Upload, Button as AntButton, Modal } from 'antd';
import { dummyRequest, getHtml, getRawData } from '../../../services/utilities';
import { Editor } from "react-draft-wysiwyg";
import { activateHomeFeature, activateListItems, createListItems, deleteHome, deleteListItems, updateHomeFeature, updateListItems } from '../../../services/apiCalls';
import { faCheckSquare, faEdit, faExclamation, faTimes, faTrash } from '@fortawesome/free-solid-svg-icons';
import { featureAlert, featureResponse, homeRefresh } from '../../../states/home';
import { EditorState } from 'draft-js';

const HomeCard = ({ img, description, status, color, types, link, parentId, list, position, google_url, app_url, get_start_url, name, link_url, title, type, id, featureImg }) => {
  const [loading, setLoading] = useState(false)
  const [file, setFile] = useState()
  const [createModal, setCreateModal] = useState(false)
  const setShowAlert = useSetRecoilState(featureAlert);
  const setResponse = useSetRecoilState(featureResponse)
  const setRefresh = useSetRecoilState(homeRefresh)
  const [editor, setEditor] = useState("")
  const [editorDesc, setEditorDesc] = useState("")
  const [viewModal, setViewModal] = useState(false)
  const [createListModal, setCreateListModal] = useState(false)
  const [updatList, setUpdatList] = useState([])
  const [form] = Form.useForm()
  const { confirm } = Modal;
  
  const onEditorStateChange = editorState => {
    setEditor(editorState);
  };
  const onEditorStateChanges = editorState => {
    setEditorDesc(editorState);
  };
  const handleUpdate = () => {
    const titleState = getRawData(title)
    const contentState = getRawData(description)
    setEditor(EditorState.createWithContent(titleState));
      setEditorDesc(EditorState.createWithContent(contentState));
      setCreateModal(true)
  }
  const onFinish = async (val) => {
    setLoading(true)
    const date = new Date()
    const fd = new FormData();
    fd.append('title', getHtml(editor))
    fd.append('description', getHtml(editorDesc))
    // fd.append('link_url', val.link_url)
    fd.append('google_url', val.google_url)
    fd.append('position', val.position)
    fd.append('app_store_url', val.app_store_url)
    fd.append('get_start_url', val.get_start_url)
    fd.append('file', file);
    try {
      const res = await updateHomeFeature({ data: fd, id })
      if (res.status) {
        setResponse({ message: res.message, title: "success" })
        setShowAlert(true)
        setRefresh(date.toTimeString())
        setCreateModal(false)
        setFile()
      } else {
        setResponse({ message: res.message || res, title: "failed" })
        setShowAlert(true)
        setFile()
      }
    } catch (error) {
      console.log(error)
    }
    setLoading(false)
    setFile()
  }
  const onFinishList = async (val) => {
    const date = new Date()
    const fd = new FormData();
    fd.append('title', getHtml(editor))
    fd.append('description', getHtml(editorDesc))
    fd.append('parent_id', val.parent_id);
    fd.append('type', val.type);
    setLoading(true)
    const res = await createListItems(fd)
    if (res.status) {
      setResponse({ message: res.message, title: "success" })
      setShowAlert(true)
      setRefresh(date.toTimeString())
      setViewModal(false)
      form.resetFields()
    } else {
      setResponse({ message: res.message || res, title: "failed" })
      setShowAlert(true)
      form.resetFields()
    }
    setLoading(false)
    form.resetFields()
  }
  
  const upDateList = async () => {
    const id = updatList.id
    setLoading(true)
    const date = new Date()
    const data = new FormData();
    data.append('title', getHtml(editor))
    data.append('description', getHtml(editorDesc))
    const res = await updateListItems({ data, id })
    if (res.status) {
      setResponse({ message: res.message, title: "success" })
      setShowAlert(true)
      setRefresh(date.toTimeString())
      setCreateListModal(false)
      form.resetFields()
    } else {
      setResponse({ message: res.message || res, title: "failed" })
      setShowAlert(true)
      form.resetFields()
    }
    setLoading(false)
    form.resetFields()
  }
    
  const offList = (id) => {
    const data = {status: 0}
    confirm({
      title: `Are you sure you want to deactivate ${title} Item?`,
      icon: <FontAwesomeIcon icon={faExclamation} color="primary" />,
      content: 'Click Ok to continue',
      onOk() {
        listShowHide(id, data)
      },
      onCancel() {
        console.log('Cancel');
      },
    });
  }

  const onList = (id) => {
    const data = {status: 1}
    confirm({
      title: `Are you sure you want to activate ${title} Item?`,
      icon: <FontAwesomeIcon icon={faExclamation} color="primary" />,
      content: 'Click Ok to continue',
      onOk() {
        listShowHide(id, data)
      },
      onCancel() {
        console.log('Cancel');
      },
    });
  }

  const listShowHide = async (id, status) => {
    const date = new Date()
    const res = await activateListItems({ data: status, id })
    if (res.status) {
      setResponse({ message: res.message, title: "success" })
      setShowAlert(true)
      setRefresh(date.toTimeString())
    } else {
      setResponse({ message: res.message || res, title: "failed" })
      setShowAlert(true)
    }
  }
  
  const confirmDeleteList = (id) => {
    confirm({
      title: `Are you sure you want to delete this Post?`,
      icon: <ExclamationCircleOutlined />,
      content: 'Click Ok to continue',
      onOk() {
        handleDeleteList(id)
      },
      onCancel() {
        console.log('Cancel');
      },
    });
  }

  const handleDeleteList = async (id) => {
    const date = new Date()
    const res = await deleteListItems(id)
    if (res.status) {
      setResponse({ message: res.message, title: "success" })
      setShowAlert(true)
      setRefresh(date.toTimeString())
    } else {
      setResponse({ message: res.message || res, title: "failed" })
      setShowAlert(true)
    }
  }
  const openUpdate = (e)=>{
    if (e.title) {
      const contentState = getRawData(e.title)
      setEditor(EditorState.createWithContent(contentState));
    }
    if (e.description) {
      const contentStateDesc = getRawData(e.description)
      setEditorDesc(EditorState.createWithContent(contentStateDesc));
    }
    setCreateListModal(true)
    setUpdatList(e)
  }
  const getBase64 = (img, callback) => {
    const reader = new FileReader();
    reader.addEventListener('load', () => callback(reader.result));
    reader.readAsDataURL(img);
  }

  const handleChange = info => {
    if (info.file.status === 'done') {
      // Get this url from response in real world.
      getBase64(info.file.originFileObj, imageUrl => {
        setFile(info.file.originFileObj)
      });
    }
  };

  const offVul = (id) => {
    const data = {status: 0}
    console.log(id)
    confirm({
      title: `Are you sure you want to activate ${name}?`,
      icon: <FontAwesomeIcon icon={faExclamation} color="primary" />,
      content: 'Click Ok to continue',
      onOk() {
        handleShowHide(id, data)
      },
      onCancel() {
        console.log('Cancel');
      },
    });
  }

  const onVul = (id) => {
    const data = {status: 1}
    console.log(id)
    confirm({
      title: `Are you sure you want to activate ${name}?`,
      icon: <FontAwesomeIcon icon={faExclamation} color="primary" />,
      content: 'Click Ok to continue',
      onOk() {
        handleShowHide(id, data)
      },
      onCancel() {
        console.log('Cancel');
      },
    });
  }

  const handleShowHide = async (id, status) => {
    const date = new Date()
    console.log(id)
    console.log(status)
    const res = await activateHomeFeature({ data: status, id })
    if (res.status) {
      setResponse({ message: res.message, title: "success" })
      setShowAlert(true)
      setRefresh(date.toTimeString())
    } else {
      setResponse({ message: res.message || res, title: "failed" })
      setShowAlert(true)
    }
  }

  const confirmDelete = (id) => {
    confirm({
      title: `Are you sure you want to delete this Post?`,
      icon: <ExclamationCircleOutlined />,
      content: 'Click Ok to continue',
      onOk() {
        handleDelete(id)
      },
      onCancel() {
        console.log('Cancel');
      },
    });
  }

  const handleDelete = async (id) => {
    const date = new Date()
    const res = await deleteHome(id)
    if (res.status) {
      setResponse({ message: res.message, title: "success" })
      setShowAlert(true)
      setRefresh(date.toTimeString())
    } else {
      setResponse({ message: res.message || res, title: "failed" })
      setShowAlert(true)
    }
  }
  return (
    <>
      <Card border="light" className="shadow-sm mb-4" style={{backgroundColor: color ? color : 'white'}}>
        <Card.Body>
          {type === "home" ?
            <Row>
              <Col xs={12} md={6} xl={6} lg={6}>
                <img src={img} alt="hero home" />
              </Col>
              <Col xs={12} md={6} xl={6} lg={6}>
                <p dangerouslySetInnerHTML={{ __html: title }} />
                <p dangerouslySetInnerHTML={{ __html: description }} />
                <div>
                  <Button variant="success" size="sm" className="text-white me-3" onClick={() => handleUpdate()}>
                    <FontAwesomeIcon icon={faEdit} />
                  </Button>
                  <Button size="sm" variant="primary" className="text-white m-3" onClick={() => confirmDelete(id)}>
                    <FontAwesomeIcon icon={faTrash} />
                  </Button>
                {status === 1 ?
                  <Button variant="primary" size="sm" className="text-white me-3" onClick={()=>offVul(id)}>
                    <FontAwesomeIcon icon={faTimes} />
                  </Button>:
                  <Button variant="secondary" size="sm" className="text-white me-3" onClick={()=>onVul(id)}>
                    <FontAwesomeIcon icon={faCheckSquare} />
                  </Button>
                }
                </div>
                {name === 'Sales Point' && list === [] &&
                  <AntButton type='primary' onClick={() => setViewModal(true)}>Create Feature</AntButton>
                }
              {list &&
                <Row className='border text-center border-2px border-solid'>
                  <Col xs={12} md={12} xl={12} lg={12}>
                    <p dangerouslySetInnerHTML={{ __html: list.title }} />
                    <p dangerouslySetInnerHTML={{ __html: list.description }} />
                  </Col>                      
                  <Col xs={12} md={12} xl={12} lg={12}>
                    <Button variant="success" size="sm" className="text-white m-1" onClick={() => openUpdate(list)}>
                      <FontAwesomeIcon icon={faEdit} />
                    </Button>
                    <Button size="sm" variant="primary" className="text-white m-1" onClick={() => confirmDeleteList(list.id)}>
                      <FontAwesomeIcon icon={faTrash} />
                    </Button>
                    {list.status === 1 ?
                      <Button variant="primary" size="sm" className="text-white m-1" onClick={()=>offList(list.id)}>
                        <FontAwesomeIcon icon={faTimes} />
                      </Button>:
                      <Button variant="secondary" size="sm" className="text-white m-1" onClick={()=>onList(list.id)}>
                        <FontAwesomeIcon icon={faCheckSquare} />
                      </Button>
                    }
                  </Col>
                </Row>
              }
              </Col>
            </Row> :
            <div>
              {featureImg && 
                <img src={img} style={{}} alt="features" />
              }
              <p dangerouslySetInnerHTML={{ __html: title }} />
              <p dangerouslySetInnerHTML={{ __html: description }} />
              <Button variant="success" size="sm" className="text-white me-3" onClick={() => handleUpdate()}>
                <FontAwesomeIcon icon={faEdit} />
              </Button>
              <Button size="sm" variant="primary" className="text-white m-3" onClick={() => confirmDelete(id)}>
                <FontAwesomeIcon icon={faTrash} />
              </Button>
              {status === 1 ?
                <Button variant="primary" size="sm" className="text-white me-3" onClick={()=>offVul(id)}>
                  Deactivate
                </Button>:
                <Button variant="secondary" size="sm" className="text-white me-3" onClick={()=>onVul(id)}>
                  Activate
                </Button>
              }
            </div>}
        </Card.Body>
      </Card>
      {/*update merchant hero start */}
      <Modal
        title="Update Home Content "
        centered
        visible={createModal}
        footer={null}
        onCancel={() => setCreateModal(false)}
      >
        <Form form={form} onFinish={onFinish} layout="vertical" initialValues={{ title, link_url, type:types, position, google_url, app_url, get_start_url, description, image_url: img }}>
          <Form.Item label="Title" name="title" rules={[{ required: true }]}>
            {/* <Input /> */}
            <Editor
              editorState={editor}
              editorClassName="px-3 border border-gray-1"
              editorStyle={{
                height: 50,
                overflow: 'auto',
              }}
              onEditorStateChange={onEditorStateChange}
            />
          </Form.Item>
          <Form.Item label="Description" name="description" rules={[{ required: true }]}>
            {/* <Input.TextArea /> */}
            <Editor
              editorState={editorDesc}
              editorClassName="px-3 border border-gray-1"
              editorStyle={{
                height: 100,
                overflow: 'auto',
              }}
              onEditorStateChange={onEditorStateChanges}
            />
          </Form.Item>
          <Form.Item label="Position" name="position">
            <Input type='number' />
          </Form.Item>
          {types !== 'connect' && 
            <Form.Item label="Google Play Link" name="google_url">
              <Input />
            </Form.Item>
          }
          <Form.Item label={types === 'connect' ?"Edit Brochure Link" :"App Store Link"} name="app_url">
            <Input />
          </Form.Item>
          <Form.Item label="Get Started Link" name="get_start_url">
            <Input />
          </Form.Item>
          {/* {link && */}
          <Form.Item label="" hidden name="type">
            <Input hidden />
          </Form.Item>
          {/* }
          {featureImg && */}
          <Form.Item >
            <Upload onChange={handleChange} customRequest={dummyRequest} maxCount={1}>
              <AntButton icon={<InboxOutlined />}>{types === 'connect' ? "Upload Brochure" : "Upload Image"}</AntButton>
            </Upload>
          </Form.Item>
            {/* } */}
          <Form.Item>
            <AntButton type="primary" htmlType="submit" loading={loading}>
              Update
            </AntButton>
          </Form.Item>
        </Form>
      </Modal>
      {/**update merchant hero end */}
      <Modal
        title="Add POS Feature"
        centered
        visible={viewModal}
        footer={null}
        onCancel={() => setViewModal(false)}
      >
        <Form form={form} onFinish={onFinishList} layout="vertical">
          <Form.Item label="Title" name="title" rules={[{ required: true }]}>
            {/* <Input /> */}
            <Editor
              editorState={editor}
              editorClassName="px-3 border border-gray-1"
              editorStyle={{
                height: 50,
                overflow: 'auto',
              }}
              onEditorStateChange={onEditorStateChange}
            />
          </Form.Item>
          <Form.Item label="Description" name="description" rules={[{ required: true }]}>
            {/* <Input /> */}
            <Editor
              editorState={editorDesc}
              editorClassName="px-3 border border-gray-1"
              editorStyle={{
                height: 100,
                overflow: 'auto',
              }}
              onEditorStateChange={onEditorStateChanges}
            />
          </Form.Item>
          <Form.Item initialValue={parentId} hidden name="parent_id">
            <Input hidden />
          </Form.Item>
          <Form.Item initialValue='home' hidden name="type">
            <Input hidden />
          </Form.Item>
          <Form.Item>
            <AntButton type="primary" htmlType="submit" loading={loading}>
              Create
            </AntButton>
          </Form.Item>
        </Form>
      </Modal>
      <Modal
        title="Update POS Feature"
        centered
        visible={createListModal}
        footer={null}
        onCancel={() => setCreateListModal(false)}
      >
        <Form form={form} onFinish={upDateList} layout="vertical">
          <Form.Item label="Edit Title" initialValue={updatList.title} name="title" rules={[{ required: true }]}>
            {/* <Input /> */}
            <Editor
              editorState={editor}
              editorClassName="px-3 border border-gray-1"
              editorStyle={{
                height: 50,
                overflow: 'auto',
              }}
              onEditorStateChange={onEditorStateChange}
            />
          </Form.Item>          
          <Form.Item label="Description" initialValue={updatList.description} name="description" rules={[{ required: true }]}>
            {/* <Input /> */}
            <Editor
              editorState={editorDesc}
              editorClassName="px-3 border border-gray-1"
              editorStyle={{
                height: 50,
                overflow: 'auto',
              }}
              onEditorStateChange={onEditorStateChanges}
            />
          </Form.Item>
          <Form.Item>
            <AntButton type="primary" htmlType="submit" loading={loading}>
              Update
            </AntButton>
          </Form.Item>
        </Form>
      </Modal>
    </>
  )
}

export default HomeCard
